export const INITIAL_SUPPLIERS = [
  {
    id: "SUP-001",
    name: "Gemini Edibles & Fats (Freedom Refined Oils, Hyderabad)",
    contactPerson: "P. Muralidhar Rao",
    phone: "+91 98490 22334",
    email: "orders@gefindia.net",
    city: "Hyderabad",
    state: "Telangana",
    paymentTerms: "Net 21 Days",
    performanceRating: 4.9,
    onTimeDeliveryRate: 98,
    priceCompetitiveness: "Highly Competitive",
    outstandingBalance: 185000,
    totalPurchasesYTD: 2450000
  },
  {
    id: "SUP-002",
    name: "Telangana State Agro Industries Development Corp",
    contactPerson: "K. Sudhakar",
    phone: "+91 98490 33445",
    email: "procurement@telanganaagro.gov.in",
    city: "Hyderabad",
    state: "Telangana",
    paymentTerms: "Net 30 Days",
    performanceRating: 4.7,
    onTimeDeliveryRate: 95,
    priceCompetitiveness: "Govt Subsidized Rate",
    outstandingBalance: 320000,
    totalPurchasesYTD: 3800000
  },
  {
    id: "SUP-003",
    name: "Bowenpally APMC Grains & Sona Masoori Mandi",
    contactPerson: "N. Ramachandraiah",
    phone: "+91 98490 44556",
    email: "bowenpallymandi@gmail.com",
    city: "Secunderabad",
    state: "Telangana",
    paymentTerms: "Cash on Delivery / 7 Days",
    performanceRating: 4.8,
    onTimeDeliveryRate: 97,
    priceCompetitiveness: "Direct Mandi Wholesale",
    outstandingBalance: 95000,
    totalPurchasesYTD: 1980000
  },
  {
    id: "SUP-004",
    name: "Hindustan Unilever Ltd - Uppal Distribution Hub",
    contactPerson: "R. Venkat Rao",
    phone: "+91 98490 55667",
    email: "uppal.dist@hul.com",
    city: "Hyderabad",
    state: "Telangana",
    paymentTerms: "Net 14 Days",
    performanceRating: 4.9,
    onTimeDeliveryRate: 99,
    priceCompetitiveness: "Manufacturer Direct",
    outstandingBalance: 140000,
    totalPurchasesYTD: 1850000
  },
  {
    id: "SUP-005",
    name: "Warangal Spices & Guntur Red Chilly Mandi",
    contactPerson: "B. Satyanarayana",
    phone: "+91 98490 66778",
    email: "warangalspices@rediffmail.com",
    city: "Warangal",
    state: "Telangana",
    paymentTerms: "Net 21 Days",
    paymentTermsCode: "NET21",
    performanceRating: 4.6,
    onTimeDeliveryRate: 94,
    priceCompetitiveness: "Origin Source Pricing",
    outstandingBalance: 78000,
    totalPurchasesYTD: 920000
  },
  {
    id: "SUP-006",
    name: "ITC Limited - Sanath Nagar Depot (Aashirvaad / Sunfeast)",
    contactPerson: "Mohan Krishna",
    phone: "+91 98490 77889",
    email: "sanathnagar.orders@itc.in",
    city: "Hyderabad",
    state: "Telangana",
    paymentTerms: "Net 15 Days",
    performanceRating: 4.9,
    onTimeDeliveryRate: 98,
    priceCompetitiveness: "Standard FMCG Slab",
    outstandingBalance: 125000,
    totalPurchasesYTD: 1620000
  },
  {
    id: "SUP-007",
    name: "Heritage Foods Limited - Panjagutta Central Dairy",
    contactPerson: "D. Srinivas",
    phone: "+91 98490 88990",
    email: "dairy.orders@heritagefoods.in",
    city: "Hyderabad",
    state: "Telangana",
    paymentTerms: "Daily / 3 Days Cycle",
    performanceRating: 4.8,
    onTimeDeliveryRate: 99,
    priceCompetitiveness: "Daily Fresh Rate",
    outstandingBalance: 34000,
    totalPurchasesYTD: 640000
  },
  {
    id: "SUP-008",
    name: "Tata Consumer Products - Nacharam Logistics Park",
    contactPerson: "P. V. Sharma",
    phone: "+91 98490 99001",
    email: "nacharam.tata@tataconsumer.com",
    city: "Hyderabad",
    state: "Telangana",
    paymentTerms: "Net 21 Days",
    performanceRating: 4.9,
    onTimeDeliveryRate: 96,
    priceCompetitiveness: "Corporate Tier-1",
    outstandingBalance: 98000,
    totalPurchasesYTD: 1350000
  }
];

export const initialSuppliers = INITIAL_SUPPLIERS;

